import { getMyUserProfile } from '@wix/ambassador-data-services-profile-client-v4-profile-field-data/http'
import { tryCatch } from '@wix/funnel-utils'

import { withMonitoring } from '../../../monitoring/withMonitoring'
import { ambassadorHttpClient } from '../../httpClient'

export const isUserNewlyRegistered = async (): Promise<boolean | null> => {
  const request = () => ambassadorHttpClient.request(getMyUserProfile({ fields: ['registration_date'] }))
  const [, response] = await tryCatch(() => withMonitoring(request, 'queryBiProfile'))

  const registrationDate = Number(response?.data.fields?.registration_date?.aSingleValue?.aLong)
  if (Number.isNaN(registrationDate)) {
    return null
  }

  return Date.now() - registrationDate < DAY_IN_MS
}

export const DAY_IN_MS = 24 * 60 * 60 * 1000
